import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, PLATFORM_ID } from '@angular/core';
import { faqItems } from '../../shared/constants/app-enums';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent {
  faqItems = faqItems; // Update this constant in ENUM file, also used in app.component.ts

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private cdRef: ChangeDetectorRef,
  ) { }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.cdRef.detectChanges();
    }
  }
}
